import React from "react";
import { Callout } from "@blueprintjs/core";

import Services from "./Services";
//import Packages from "./Packages";

export default function Maintenance() {
  return (
    <div>
      <Callout title="Maintenance (the following actions may have irreversible effects on the proper functioning of the park)">
      <Services />
      {/* <Packages /> */}
      </Callout>
    </div>
  );
}